import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { get } from '../../helpers/api_helper';
import { parseDimensions } from './BoxSelection';

export default function ListingBoxPicker({ children }) {
  const { values, setValues, setFieldValue } = useFormikContext();
  const [boxes, setBoxes] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let active = true;
    get('/api/listings/boxes').then((rows) => { if (active) setBoxes(rows); })
      .catch(() => { if (active) setError('Could not load box sizes. Reload to try again.'); });
    return () => { active = false; };
  }, []);
  useEffect(() => {
    if (!boxes) return;
    let selected = boxes.find((box) => String(box.id) === String(values.box_id));
    if (values.box_id === undefined && !values.id) {
      selected = boxes.find((box) => {
        const dimensions = parseDimensions(`${box.length}x${box.width}x${box.height}`);
        return dimensions?.length === 11 && dimensions.width === 7 && dimensions.height === 5;
      });
    }
    const nextId = selected?.id || null;
    const dimensions = selected
      ? `${selected.length}x${selected.width}x${selected.height}` : values.ship_dims;
    if (values.box_id !== nextId || values.ship_dims !== dimensions
      || values.box_id_locked !== true) {
      setValues((current) => ({
        ...current,
        box_id: nextId,
        box_id_locked: true,
        ship_dims: dimensions,
      }));
    }
  }, [boxes, values.id, values.box_id, values.ship_dims, values.box_id_locked, setValues]);
  useEffect(() => {
    const selected = boxes?.find((box) => String(box.id) === String(values.box_id));
    if (!selected) return;
    const largeItem = selected.is_large === true || Number(selected.is_large) === 1;
    setFieldValue('large_item', largeItem);
  }, [boxes, values.box_id, setFieldValue]);
  return (
    <>
      <div className="row mt-4 mb-4">
        <Label for="listing-box" className="col-sm-3 col-form-label">Box Size</Label>
        <div className="col-sm-5">
          <select
            id="listing-box"
            className="form-control"
            value={values.box_id || ''}
            disabled={!boxes}
            onChange={(event) => {
              const selected = boxes.find((box) => String(box.id) === event.target.value);
              setValues((current) => ({
                ...current,
                box_id: selected?.id || null,
                box_id_locked: true,
                large_item: selected
                  ? selected.is_large === true || Number(selected.is_large) === 1
                  : current.large_item,
                ship_dims: selected
                  ? `${selected.length}x${selected.width}x${selected.height}` : current.ship_dims,
              }));
            }}
          >
            <option value="">{boxes ? 'No matching box' : 'Loading boxes…'}</option>
            {boxes && boxes.map((box) => (
              <option key={box.id} value={box.id}>
                {`${box.box_name} (${box.length} × ${box.width} × ${box.height} in)`}
              </option>
            ))}
          </select>
          {error && <div className="text-danger">{error}</div>}
        </div>
      </div>
      {(boxes || error) && !values.box_id && children}
    </>
  );
}

ListingBoxPicker.propTypes = {
  children: PropTypes.node.isRequired,
};
